export default "__VITE_ASSET__OIe58H7f__"